import React from 'react';
import { Backdrop, CircularProgress, Box } from '@mui/material';
import { useUIStore } from '../../store/useStore';

const LoadingSpinner = () => {
  const { loading } = useUIStore();

  return (
    <Backdrop
      sx={{ 
        color: '#fff', 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
      open={loading}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress 
          color="inherit" 
          size={60}
          thickness={4}
        />
        <Box sx={{ mt: 2, fontSize: '1.1rem' }}>
          Cargando...
        </Box>
      </Box>
    </Backdrop>
  );
};

export default LoadingSpinner; 